import StudentFacingData from "../../../../interfaces/StudentFacingData";

interface BookResults {
  classId: string;
  bookName: string;
  coverImageUrl?: string;
  bookId: string;
  assignmentId: string;
  className: string;
  wordCount: number;
  uniqueWordCount: number;
  estimatedTime: number;
  actualTime?: number;
  isNew: boolean;
  accuracy?: number;
  wordsPerMinute?: number;
  completion: number;
  studentFacingData?: StudentFacingData;
  turnedIn: boolean;
  viewType: undefined | "text" | "pdf" | "external" | "paperback";
}

export const emptyBookResult = (): BookResults => ({
  classId: "",
  bookName: "",
  coverImageUrl: "",
  bookId: "",
  assignmentId: "",
  className: "",
  wordCount: 0,
  uniqueWordCount: 0,
  estimatedTime: 0,
  actualTime: 0,
  isNew: true,
  accuracy: 0,
  wordsPerMinute: 0,
  completion: 0,
  studentFacingData: { accuracy: false, completionPercentage: false, wordsPerMinute: false },
  turnedIn: false,
  viewType: undefined,
});

export default BookResults;
